import { TPlanPackage } from 'plans/types';
import { translate } from 'utils/i18n';

export const getPlanPackageDefaults = (
    planPackageType: string
): TPlanPackage => {
    switch (planPackageType) {
        case 'professional':
            return {
                title: translate('plans.professional.title'),
                description: translate('plans.professional.description'),
                features: [
                    translate('plans.professional.features.feature1'),
                    translate('plans.professional.features.feature2'),
                    translate('plans.professional.features.feature3'),
                    translate('plans.professional.features.feature4'),
                    translate('plans.professional.features.feature5'),
                    translate('plans.professional.features.feature6'),
                    translate('plans.professional.features.feature7'),
                    translate('plans.professional.features.feature8'),
                ],
                order: 0,
                weight: 1,
            };
        case 'team':
            return {
                title: translate('plans.team.title'),
                description: translate('plans.team.description'),
                features: [
                    translate('plans.team.features.feature1'),
                    translate('plans.team.features.feature2'),
                    translate('plans.team.features.feature3'),
                    translate('plans.team.features.feature4'),
                    translate('plans.team.features.feature5'),
                    translate('plans.team.features.feature6'),
                    translate('plans.team.features.feature7'),
                ],
                order: 1,
                topChoice: true,
                weight: 2,
            };
        case 'company':
            return {
                title: translate('plans.company.title'),
                description: translate('plans.company.description'),
                features: [
                    translate('plans.company.features.feature1'),
                    translate('plans.company.features.feature2'),
                    translate('plans.company.features.feature3'),
                    translate('plans.company.features.feature4'),
                    translate('plans.company.features.feature5'),
                    translate('plans.company.features.feature6'),
                    translate('plans.company.features.feature7'),
                    translate('plans.company.features.feature8'),
                ],
                order: 2,
                weight: 3,
            };
        default:
            return {
                title: '',
                description: '',
                features: [],
                order: 0,
                weight: 0,
            };
    }
};

export const getAllPlanPackageDefaults = () => ({
    professional: getPlanPackageDefaults('professional'),
    team: getPlanPackageDefaults('team'),
    company: getPlanPackageDefaults('company'),
});
